import { render, staticRenderFns } from "./SaleProducts.vue?vue&type=template&id=c88cab74"
import script from "./SaleProducts.vue?vue&type=script&lang=js"
export * from "./SaleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports